import * as React from 'react'
import {Box} from "@mui/material";
import {SkuInfoBlock} from "@components";
import { useBuildExternalURL } from "@hooks"
import {productPagesModalData} from "../../@signals";

export default function skuColumn() {
	return [{
        name: 'category', label: 'Category',
        options: {
            display: 'excluded'
        }
    },{
        name: 'brand', label: 'Brand',
        options: {
            display: 'excluded'
        }
    },{
		name:'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	},{
		name: 'skuName', label: 'Product Name',
		options: {
			filterType: 'textField',
			headerAlign: 'left',
			setCellHeaderProps: () => ({ sx: { minWidth: 300 }}),
			customBodyRowRenderLite: (value, row) => {
				const { category, brand, ean, siteID, productID, date, reference } = row
				const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })

				return <Box>
					<SkuInfoBlock
						sku={value}
						category={category}
						brand={brand}
						ean={ean}
						reference={reference}
						productURL={productURL}
						displayShowDetails={true}
						onClick={() => productPagesModalData.value = row}
					/>
				</Box>
			}
		}
	}]
}